import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import LogisticsHero from './components/LogisticsHero';
import LogisticsResources from './components/LogisticsResources';
import StorageResources from './components/StorageResources';
import ResourceMatching from './components/ResourceMatching';
import LogisticsCTA from './components/LogisticsCTA';

const LogisticsPage = () => {
  return (
    <div className="min-h-screen bg-neutral-50">
      <Navbar />
      <main className="pt-20">
        <LogisticsHero />
        <LogisticsResources />
        <StorageResources />
        <ResourceMatching />
        <LogisticsCTA />
      </main>
      <Footer />
    </div>
  );
};

export default LogisticsPage;